import { render, staticRenderFns } from "./KGPSQP.vue?vue&type=template&id=2cf28b1d&scoped=true"
import script from "./KGPSQP.vue?vue&type=script&lang=js"
export * from "./KGPSQP.vue?vue&type=script&lang=js"
import style0 from "./KGPSQP.vue?vue&type=style&index=0&id=2cf28b1d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf28b1d",
  null
  
)

export default component.exports